import API from '../libraries/API';

/**
 * Upload image to S3
 * @param {File} file - Image file
 */
const uploadImage = file => API.post('s3-cloud/upload', { file });

export default { uploadImage }
